<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="سعيد">
<h1><span dir="rtl">سَعيد</span></h1>
<div class="section level2" id="happy">
<h2>Happy</h2>
<p><span dir="rtl">أنت دائمًا أفضل من شخص آخر، تأكد دائمًا</span></p>
<p><span dir="rtl">حتى لو كان هناك شخص أفضل منك هناك من هو أسوأ منك.</span></p>
<br/>
<p style="text-align:center; direction:ltr">You are always better than someone else, be sure always</p>
<p style="text-align:center; direction:ltr">Even if there is someone better than you there is who is worse than you.</p>
<br/><p style="text-align:center">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?13f0a71a